// extracted by mini-css-extract-plugin
export var divider = "_xk-0";